// extracted by mini-css-extract-plugin
module.exports = {"component":"modal-component--1KoE1"};